<template>
  <div class="AnLe">
    <!--春季&冬季  春季：3-5月 冬季：12-2-->
    <div v-if="(nowMoth >= 1 && nowMoth <= 5) || nowMoth == 12">
      <div class="springAndwinter">
        <div class="banner">
          <img width="100%" src="../../../assets/img/AnLe/Anle_Banner_springAndwinter.jpg" alt="" srcset="">
        </div>
        <div class="con1">
          <div class="con1_leftBox">
            <img width="100%" src="../../../assets/img/AnLe/AnLe_orange.png" alt="" srcset="">
          </div>
          <div class="con1_rightBox">
            <div class="top_title">
              <div style="display: flex;justify-content: center;align-items: center;">
                <img style="margin-right:5px;" src="../../../assets/img/AnLe/springAndwinter_square.png" alt="" srcset="">
                <span>简介</span>
              </div>
              <!-- <span style="display:block">>></span> -->
            </div>
            <div class="cont">
              <p>
                黄果柑，又名青果、黄金果。果实圆球形，果形端正，果蒂、果顶平，果皮黄色、鲜艳、有光泽。汉源县安乐镇正是黄果柑的生长和发源地之一，阳光城给黄果柑提供了充足的光照，正是这充足的光照、适宜的海拔和巨大的昼夜温差使得汉源的黄果柑具有汁水丰盈、入口爆浆、肉质细腻、清新爽口、果味浓郁的独特口感。安乐镇光照充足，气候冷凉干燥，昼夜温差大，正是这得天独厚的自然条件，使得安乐黄果柑品质极佳。如今漫山遍野金灿灿的黄果柑不仅是安乐镇广大群众的致富果，更是安乐镇产业发展的一道风景线，写满了安乐镇群众致富的幸福笑容，更扮靓了安乐镇群众奔康的富强梦想。
              </p>
              <p>
                安乐镇黄果柑品种不断更新优化，种植技术不断提升，现在安乐镇黄果柑有着品相好、水分足、酸甜适宜等特点。小小的黄果柑，成为当地果农经济收入的主要来源。
              </p>
            </div>
          </div>
        </div>
        <!-- 热门事项 -->
        <!-- <ConvenientService :matterList="matterList" :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/AnLe/springAndwinter_square.png')" color="#DC6A06"
          borderBottomColor="#EBA970" boxBorderColor="#EBA970" btnBJcolor="rgb(234, 182, 134)" hoverBJcolor="#DB7312">
        </ConvenientService> -->
        <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/AnLe/springAndwinter_square.png')" color="#DC6A06" borderBottomColor="#EBA970"></GovernmentServices>
      </div>
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/AnLe/springAndwinter_square.png')" color="#DC7312"
        borderBottomColor="#EBA970" boxBorderColor="#EBA970"></ztxzList>
    </div>

    <!-- 乡镇特色 -->
    <div v-else>
      <div class="feature">
        <div class="banner">
          <img width="100%" src="../../../assets/img/AnLe/AnLe_Banner.jpg" alt="" srcset="">
        </div>
        <div class="con1">
          <div class="con1_leftBox">
            <img width="100%" src="../../../assets/img/AnLe/ganganjiuPic.png" alt="" srcset="">
          </div>
          <div class="con1_rightBox">
            <div class="top_title">
              <div style="display: flex;justify-content: center;align-items: center;">
                <img style="margin-right:5px;" src="../../../assets/img/AnLe/square.png" alt="" srcset="">
                <span>简介</span>
              </div>
              <span style="display:block">>></span>
            </div>
            <div class="cont">
              <p style="line-height: 35px;">
                “杆杆酒”在彝语中叫“芝衣”，又称“泡水酒” “咂酒”，是彝族人民喜庆节日时用来招待客人的一种别具风味的水酒。这种酒亦采用玉米、高粱和荞子酿制而成，沙坪彝族村的杆杆酒用坛子盛装，饮用时，用细竹秤插入坛中吸饮或用它接入酒杯饮用。杆杆酒以其吸饮工具而得名，“杆杆酒”营养丰富、口感纯厚。
              </p>
              <div style="width:100%;margin-top:10px;">
                <img style="width:100%;float:right;" src="../../../assets/img/AnLe/jianjiePic.png" alt="">
              </div>
            </div>
          </div>
        </div>
        <GovernmentServices :mapId="mapId" :name="name" :imgSrc="require('../../../assets/img/AnLe/square.png')" color="#8C2F2A" borderBottomColor="#AC6C6B"></GovernmentServices>
      </div>
      <ztxzList :villages="villages" :imgSrc="require('../../../assets/img/AnLe/square.png')" color="#8C2F2A" borderBottomColor="#AC6C6B"
        boxBorderColor="#DB908C"></ztxzList>
    </div>
  </div>
</template>
<script>
import ztxzList from "@/components/ztxzList/index";
import ConvenientService from "@/components/ConvenientService/index";
import GovernmentServices from "@/components/GovernmentServices/index";
import { getServerDate, matterQuery } from "@/api/map/index"
import { mixin } from "../../../mixin";
export default {
  name: 'AnLe',
  components: { ztxzList, ConvenientService,GovernmentServices },
  data() {
    return {
      nowMoth: null, //当前月份
      mapId: [],
      matterList: [],  //事项列表
      villages: [],  //乡镇列表
      name:'安乐镇',
    };
  },
  mixins:[mixin],
  created() {
    this.$emit('public_header', false);

  },
  // mounted() {
  //   // if (this.$route.params.mapId) {
  //   //   sessionStorage.setItem('mapId', this.mapId)
  //   // }
  //   // if (sessionStorage.getItem('mapId')) {
  //   //   this.mapId = sessionStorage.getItem('mapId');
  //   // }
  //   this.getData()
  //   this.getMatterList()

  //   // this.getData(Date.now());
  //   // console.log(this.$route.params, '??')
  // },

  // methods: {
  //   // 获取服务器当前时间
  //   getData() {
  //     getServerDate().then(res => {
  //       // console.log(res,'时间')
  //       if (res.data.code == 200) {
  //         this.FormatData(res.data.data)
  //       }
  //     })
  //   },
  //   // 日期时间格式化
  //   FormatData(n) {
  //     // console.log(n,'时间')
  //     let now = new Date(n),
  //       // y = now.getFullYear();
  //       m = now.getMonth() + 1;
  //     // d = now.getDate();
  //     // return y + "-" + (m < 10 ? "0" + m : m) + "-" + (d < 10 ? "0" + d : d) + " " + now.toTimeString().substr(0, 8);
  //     this.nowMoth = m;
  //   },
  //   getMatterList() {
  //     let query = {
  //       id: this.mapId
  //     }
  //     matterQuery(query).then(res => {
  //       // console.log(res,'事项列表')
  //       if (res.data.code == 200) {
  //         if (res.data.rows && res.data.rows.length > 0) {
  //           this.matterList = res.data.rows.slice(0, 5);
  //         } else { 
  //           // this.$message.error('暂无事项！')
  //           console.log('暂无事项')
  //          }
  //       } else {
  //         this.$message.error('事项列表获取失败！')
  //       }
  //     })
  //   }
  // },
};
</script>
<style scoped>
.AnLe {
  background: url('../../../../src/assets/img/AnLe/AnLeBj.png');
  background-size: 100% 100%;
}

.banner {
  width: 100%;
}

.con1 {
  width: 1200px;
  margin: 0 auto;
  display: flex;
  justify-content: space-between;
  margin-top: 20px;
}

.con1 .con1_leftBox,
.con1 .con1_rightBox {
  width: 49%;
}

.con1 .con1_rightBox .cont {
  text-align: left;
  text-indent: 2em;
  margin: 10px 0;
  height: 83%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  line-height: 25px;  
}

.top_title {
  color: #DC7312;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #EBA970;
  height: 12%;
}

.feature .top_title {
  color: #8C2F2A;
  font-size: 25px;
  font-weight: bold;
  display: flex;
  justify-content: space-between;
  border-bottom: 2px solid #8C2F2A;
  height: 12%;
}
</style>